// import React from "react";
// import { IMAGES } from "../Images";
// // import * as IMAGES from "../Images";

// import "./Loader.css";

// class Loader extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {};
//   }

//   render = () => {
//     return (
//       <div className="loader-container">
//         <img src={IMAGES.LOGO} alt="Icon Loader" style={{ width: "325px" }} />
//       </div>
//     );
//   };
// }

// export default Loader;

import React, { Component } from "react";
import "./Loader.css"; // Make sure to create this CSS file

class Loader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: 0,
    };

    this.animationFrameId = null;
    this.lastTime = 0;
    this.animationSpeed = 0.13;
  }

  componentDidMount() {
    this.startAnimation();
  }

  componentWillUnmount() {
    this.stopAnimation();
  }

  startAnimation = () => {
    this.lastTime = 0;
    this.animate = this.animate.bind(this);
    this.animationFrameId = requestAnimationFrame(this.animate);
  };

  stopAnimation = () => {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }
  };

  animate = (currentTime) => {
    if (!this.lastTime) this.lastTime = currentTime;
    const deltaTime = currentTime - this.lastTime;

    this.setState((prevState) => {
      const newProgress = prevState.progress + deltaTime * this.animationSpeed;
      return {
        progress: newProgress >= 100 ? newProgress % 100 : newProgress,
      };
    });

    this.lastTime = currentTime;
    this.animationFrameId = requestAnimationFrame(this.animate);
  };

  // Create a smoother heartbeat curve using cubic bezier curves
  getPath = () => {
    const { progress } = this.state;
    const cycle = progress % 100;
    const maxWidth = 400;
    const baselineY = 50;

    // Define control points for a complete heartbeat pattern
    const pattern = [
      // Starting point
      { x: 0, y: baselineY, type: "M" },

      // Flat line segment
      { x: 100, y: baselineY, type: "L" },

      // First small bump (using cubic bezier for smoothness)
      { x: 120, y: 35, type: "S", cx: 110, cy: 35 },
      { x: 140, y: baselineY, type: "S", cx: 130, cy: baselineY },

      // Short flat segment
      { x: 160, y: baselineY, type: "L" },

      // Main heartbeat spike (smooth curves)
      { x: 180, y: 15, type: "S", cx: 170, cy: 15 },
      { x: 200, y: 85, type: "S", cx: 190, cy: 85 },
      { x: 220, y: baselineY, type: "S", cx: 210, cy: baselineY },

      // End flat line
      { x: 320, y: baselineY, type: "L" },
    ];

    // Generate path string
    let pathString = "";
    const visibleUpTo = Math.min((cycle / 100) * maxWidth, maxWidth);

    // Find where to cut the path based on current progress
    for (let i = 0; i < pattern.length; i++) {
      const point = pattern[i];

      // If this point is beyond our current progress, don't include it
      if (point.x > visibleUpTo) {
        // If this is not the first point, draw a line to the current progress point
        if (i > 0) {
          // Find the previous point
          const prevPoint = pattern[i - 1];

          // If we're between the previous point and this point
          if (prevPoint.x <= visibleUpTo) {
            // Linear interpolation for y value
            const ratio = (visibleUpTo - prevPoint.x) / (point.x - prevPoint.x);
            const y = prevPoint.y + ratio * (point.y - prevPoint.y);
            pathString += ` L ${visibleUpTo},${y}`;
          }
        }
        break;
      }

      // Add this point to the path
      switch (point.type) {
        case "M":
          pathString += `M ${point.x},${point.y}`;
          break;
        case "L":
          pathString += ` L ${point.x},${point.y}`;
          break;
        case "S":
          pathString += ` S ${point.cx},${point.cy} ${point.x},${point.y}`;
          break;
        default:
          break;
      }
    }

    return pathString;
  };

  // Calculate the position of the moving dot
  getDotPosition = () => {
    const { progress } = this.state;
    const cycle = progress % 100;
    const maxWidth = 400;
    const baselineY = 50;

    // Position on x-axis
    const x = Math.min((cycle / 100) * maxWidth, maxWidth);

    // Calculate y position based on x
    let y = baselineY; // Default to baseline

    // Different sections of the heartbeat
    if (x >= 100 && x < 140) {
      // First bump (parabolic function for smoothness)
      const relativeX = (x - 100) / 40;
      y = baselineY - Math.sin(relativeX * Math.PI) * 15;
    } else if (x >= 160 && x < 220) {
      // Main spike (more complex shape)
      const relativeX = (x - 160) / 60;
      if (relativeX < 0.33) {
        // Going up steeply
        y = baselineY - (relativeX / 0.33) * 35;
      } else if (relativeX < 0.66) {
        // Going down even more steeply
        y = baselineY - 35 + ((relativeX - 0.33) / 0.33) * 70;
      } else {
        // Returning to baseline
        y = baselineY + 35 - ((relativeX - 0.66) / 0.34) * 35;
      }
    }

    return { x, y };
  };

  render() {
    const dotPosition = this.getDotPosition();

    return (
      <div className="lifeline-container">
        <div className="lifeline-wrapper">
          <svg viewBox="0 0 400 100" className="lifeline-svg">
            <line x1="0" y1="50" x2="400" y2="50" stroke="#e5e7eb" strokeWidth="1" strokeDasharray="4,4" />

            <path d={this.getPath()} fill="none" stroke="#e02029" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx={dotPosition.x} cy={dotPosition.y} r="6" fill="#e02029" />
          </svg>
        </div>
      </div>
    );
  }
}

export default Loader;
